import React, { createContext, useEffect, useState } from "react";

// Create the context
export const CurrencyContext = createContext();

// Currency Provider component
export const CurrencyProvider = ({ children }) => {
  
  const [selectedCurrency, setSelectedCurrency] = useState("1228312"); // Default to USD



  const siteItemIdToCurrencyCode = {
    "1228312": "USD",
    "1227501": "SGD",
    "1237318": "INR",
  };

  const currencyCode = siteItemIdToCurrencyCode[selectedCurrency];

  useEffect(() => {
    const saved = localStorage.getItem("selectedCurrency");
    if (saved) {
      setSelectedCurrency(saved);
    } else {
      fetch("https://api.ipgeolocation.io/ipgeo?apiKey=c1812ee74c1d4638a243bb0fa91236ce")
        .then((res) => res.json())
        .then((data) => {
          const country = data.country_code2;
          const defaultMap = {
            US: "1228312",
            SG: "1227501",
            IN: "1237318",
          };
          if (defaultMap[country]) {
            setSelectedCurrency(defaultMap[country]);
            localStorage.setItem("selectedCurrency", defaultMap[country]);
          }
        })
        .catch((err) => console.error("Geo API error:", err));
    }
  }, []);

  return (
    <CurrencyContext.Provider value={{ selectedCurrency, setSelectedCurrency, currencyCode}}>
      {children}
    </CurrencyContext.Provider>
  );
};
